export const messages = {
  page: {
    header: {
      id: 'secureMessage.Form.Header',
      defaultMessage: 'New Message',
    },
  },
  recipient: {
    placeholder: {
      id: 'secureMessage.Form.Recipient.Placeholder',
      defaultMessage: 'To',
    },
  },
  subject: {
    placeholder: {
      id: 'secureMessage.Form.Subject.Placeholder',
      defaultMessage: 'Subject',
    },
  },
  content: {
    placeholder: {
      id: 'secureMessage.Form.Content.Placeholder',
      defaultMessage: 'Message',
    },
  },
  message: {
    placeholder: {
      id: 'secureMessage.Form.Message.Placeholder',
      defaultMessage: 'Write your message...',
    },
  },
  send: {
    label: {
      id: 'secureMessage.Form.Send.Label',
      defaultMessage: 'Send Message',
    },
  },
  cancel: {
    label: {
      id: 'secureMessage.Form.Cancel.Label',
      defaultMessage: 'Cancel',
    },
  },
  cancelPopup: {
    title: {
      id: 'secureMessage.Form.CancelPopup.Title.Label',
      defaultMessage: 'Cancel Message',
    },
    body: {
      id: 'secureMessage.Form.CancelPopup.Body.Label',
      defaultMessage: 'Are you sure you want to cancel this message?',
    },
    submitButton: {
      id: 'secureMessage.Form.CancelPopup.Submit.Label',
      defaultMessage: 'Yes',
    },
    hideButton: {
      id: 'secureMessage.Form.CancelPopup.Cancel.Label',
      defaultMessage: 'Continue Editing',
    },
  },
};
